import { useSyncExternalStore } from 'react';
import { getPendingRequestsCount, subscribeToPendingRequests } from './axios.utilities';

/** Subscribe to the global in-flight request count. */
export function usePendingRequestsCount() {
  return useSyncExternalStore(subscribeToPendingRequests, getPendingRequestsCount, getPendingRequestsCount);
}

/** True when any API requests are currently in flight. */
export function useHasPendingRequests() {
  const hasPendingRequests = () => getPendingRequestsCount() > 0;
  return useSyncExternalStore(subscribeToPendingRequests, hasPendingRequests, hasPendingRequests);
}
